// extracted by mini-css-extract-plugin
module.exports = {"noBr":"StoryItem-module--noBr--1oDDn","title":"StoryItem-module--title--1OFWL","subtitle":"StoryItem-module--subtitle--1TOwa","mobile":"StoryItem-module--mobile--28-SQ"};